import React from "react";
import { useIntl } from "react-intl";
import { toTitleCase } from "../../utils/functions";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import {
    blankFilters,
    blankExpandedLevels,
} from "../../utils/Products/functions";
import { Breadcrumbs, Link, Typography } from "@mui/material";

import ProductSearch from "../../components/Search/ProductSearch";

const ProductHeader = ({
    selectedCategory,
    productCount,
    isFilterOpen,
    setIsFilterOpen,
    setSelectedProduct,
    setShowModal,
    allProducts,
    selectedProduct,
    setSelectedCategory,
    setSelectedFilters,
    setExpandedLevels,
    setSubCategories,
}) => {
    const intl = useIntl();
    const handleSearchClick = (client) => {
        // Set the selected product and show the modal
        setSelectedProduct(client);
        setShowModal(true);
    };

    const reset = () => {
        setSelectedCategory(null);
        setSelectedFilters(blankFilters);
        setExpandedLevels(blankExpandedLevels);
        setSubCategories(null);
    };
    return (
        <div className="flex flex-col md:flex-row px-3 md:px-1 md:pl-5 mt-10 md:mt-20 mb-2 md:mb-5">
            <div className="flex flex-col gap-4 md:gap-4 w-full">
                <div className="w-full flex flex-col md:flex-row items-start md:items-center md:gap-4 px-1 ">
                    <h1 className={` text-xxl text-black font-semibold `}>
                        {intl.formatMessage({
                            id: "product.product_catalogue",
                        })}
                    </h1>
                </div>

                <div
                    className={`w-full flex flex-col-reverse md:flex-row md:items-center gap-2`}
                >
                    {" "}
                    <div className="w-full flex gap-2 md:justify-between">
                        <div className="w-full md:w-1/3">
                            <ProductSearch
                                allProducts={allProducts}
                                handleClick={handleSearchClick}
                                selectedProduct={selectedProduct}
                            />
                        </div>
                        <button
                            onClick={() => setIsFilterOpen((prev) => !prev)}
                            className="flex md:hidden justify-center items-center bg-black rounded-full text-white gap-2 text-lg md:text-base px-4 md:px-3"
                            style={{ backgroundColor: "#3e3e3e" }}
                        >
                            <HiOutlineAdjustmentsHorizontal />
                        </button>{" "}
                    </div>
                </div>
                <div className="px-1 flex justify-between items-center">
                    <Breadcrumbs
                        aria-label="product navigation"
                        sx={{
                            whiteSpace: "nowrap",
                            "& .MuiBreadcrumbs-ol": {
                                alignItems: "center",
                            },
                        }}
                    >
                        <Link
                            component="button"
                            underline={selectedCategory ? "hover" : "none"}
                            color="inherit"
                            onClick={() => reset()}
                            sx={{
                                fontSize: "1rem",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            {intl.formatMessage({ id: "product.plural" })}{" "}
                            {!selectedCategory &&
                                `(${productCount ? productCount : "..."})`}
                        </Link>
                        {selectedCategory && (
                            <Typography
                                sx={{
                                    fontSize: "1rem",

                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {toTitleCase(selectedCategory)} (
                                {productCount ? productCount : "..."})
                            </Typography>
                        )}
                    </Breadcrumbs>
                    <div className="hidden md:flex justify-end gap-3">
                        <button
                            onClick={() => setIsFilterOpen((prev) => !prev)}
                            className="flex justify-center items-center bg-black rounded-full text-white gap-2 px-3 py-2"
                        >
                            {" "}
                            <span className="hidden md:block text-xs font-semibold">
                                {isFilterOpen
                                    ? intl.formatMessage({
                                          id: "product.hide_filters",
                                      })
                                    : intl.formatMessage({
                                          id: "product.show_filters",
                                      })}
                            </span>
                            <HiOutlineAdjustmentsHorizontal />
                        </button>{" "}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductHeader;
